// cleanup_hoc_to_hooks_GENERICS
// cleanup_convert_to_typescript_file_GENERICS
// cleanup_remove_external_libraries_GENERICS

import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import capitalize from 'lodash/capitalize';

import { CaretLeftIcon } from '@glu/icons-react';

import FdicLogo, { FDIC_LOGO_VARIANTS } from 'components/fdicLogo';
import withAppStyles from 'components/withAppStyles/withAppStyles';
import { useAppConfig } from 'components/appConfig/AppConfig';
import { PREVIOUS } from 'constants.js';

import { nativeStyles, webStyles } from './PageHeader.styles';

const PageHeaderComponent = ({
  backAt,
  children,
  classes,
  fdicLogoNative,
  fdicLogoWeb,
  title
}) => {
  const history = useHistory();
  const { isNative } = useAppConfig();
  const { clickable, fdicClass, pageHeader, pageHeaderContent, pageTitle } = classes;

  // Move user back
  const onBackClick = () => {
    if (backAt === PREVIOUS) {
      history.goBack();
    } else {
      history.push({ pathname: backAt });
    }
  };

  const showFdicLogo = isNative ? fdicLogoNative : fdicLogoWeb;

  return (
    <header className={pageHeader} data-qa="page-header">
      {showFdicLogo && <FdicLogo className={fdicClass} type={FDIC_LOGO_VARIANTS.HEADER} />}
      <div className={pageHeaderContent}>
        {/* For navigation purposes, consider using WORKSPACE, needs to stay for now */}
        {isNative && backAt && <CaretLeftIcon className={clickable} onClick={onBackClick} />}

        {/* inlining the style to override GluOverrides styles */}
        <h1 className={pageTitle} style={{ marginBottom: 0 }} title={title}>
          {isNative ? title.toLowerCase().replace(/\w+/g, capitalize) : title}
        </h1>
        {children}
      </div>
    </header>
  );
};

PageHeaderComponent.defaultProps = {
  children: null,
  classes: {},
  title: '',
  backAt: '',
  fdicLogoWeb: false,
  fdicLogoNative: false
};

PageHeaderComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  backAt: PropTypes.string,
  fdicLogoWeb: PropTypes.bool,
  fdicLogoNative: PropTypes.bool
};

const StyledPageHeaderComponent = withAppStyles(
  { web: webStyles, native: nativeStyles },
  PageHeaderComponent
);

export default StyledPageHeaderComponent;
